module.exports = __webpack_public_path__ + "static/media/appcenter-login.e494fbb9.svg";